import AccountBalancesSimpleView from './AccountBalancesSimpleView'

export default AccountBalancesSimpleView
